import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    imports: [CommonModule, IconCustomComponent],
    selector: 'vn-am-header-close',
    templateUrl: 'header-close.html',
})
export class HeaderCloseComponent extends AccountMenuItemBase {
    constructor() {
        super();
    }

    close() {
        this.accountMenuService.toggle(false, {
            closedWithButton: true,
        });
    }
}
